import { PdaAccessToken } from "src/app/pda/utils/Service/pda-auth.service";

export class PdaDownloadAvvisoRequest{
  token!: PdaAccessToken;
  numeroAvviso!: string;
};
